/**
 * 房源 & 新闻访问统计
 * 
 * @Author: Focci
 * @Date: 2023-09-06 13:40:03
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-06 13:40:03
 */

'use client'

import PropTypes from 'prop-types'
import { fetchPost } from '@lib/fetch/client'
import { useEffect } from 'react'

export default function BrowsingRecordAnalyse({
  id,
  uid,
  type = 'house'
}) {
  useEffect(() => {
    const fetchParam = uid ? { type, uid } : { uid, id }
    const timer = setTimeout(() => {
      fetchPost('user-browse-record', fetchParam)
    }, 1000)

    return () => clearTimeout(timer)
  }, [id, uid, type])
}

BrowsingRecordAnalyse.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  type: PropTypes.oneOf(['news', 'house']),
}
